<template>
  <div>
    <div v-for="order in orderTrackings" :key="order.businessPrescriptionOrderId" class="tw-mb-10">
      <base-card>
        <div class="tw-my-2">
          <div class="tw-mb-6 tw-text-sm tw-flex tw-gap-4">
            <p>
              Pharmacy Order ID: <span class="tw-text-gray-500">{{ order.pharmacyOrderId }}</span>
            </p>
            <p>
              Pharmacy: <span class="tw-text-gray-500">{{ order.pharmacy }}</span>
            </p>
          </div>
          <div class="tw-flex">
            <div class="tw-relative tw-w-8" style="min-height: 200px;">
              <div class="tw-absolute tw-left-1/2 tw-top-3 tw-w-2 tw-bg-gray-200" style="transform: translateX(-50%);min-height: 200px;"></div>
              <div
                class="tw-absolute tw-left-1/2 tw-w-2 tw-bg-green-500"
                :style="{
                  transform: 'translateX(-50%)',
                  top: '12px',
                  height: (getCurrentStatusIndex(order) > 0 ? getCurrentStatusIndex(order) * stepHeight : 0) + 'px',
                }"
              ></div>
              <div
                v-for="(status, idx) in statuses"
                :key="status"
                class="tw-absolute"
                :style="{
                  left: '50%',
                  top: idx * stepHeight + 'px',
                  transform: 'translateX(-50%)',
                }"
              >
                <div
                  :class="[
                    'tw-h-6 tw-w-6 tw-rounded-full tw-border-2 tw-flex tw-items-center tw-justify-center',
                    idx <= getCurrentStatusIndex(order) ? 'tw-bg-green-500 tw-border-green-500' : 'tw-bg-white tw-border-gray-300',
                  ]"
                >
                  <svg v-if="idx <= getCurrentStatusIndex(order)" class="tw-h-4 tw-w-4 tw-text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
            </div>

            <div class="tw-flex-1 tw-pl-4">
              <div v-for="(status, idx) in statuses" :key="status" class="tw-mb-4 tw-last">
                <div class="tw-flex tw-items-center tw-justify-between">
                  <div
                    :class="[
                      'tw-inline-block tw-px-4 tw-py-1.5 tw-rounded-full tw-font-light tw-text-sm',
                      idx === getCurrentStatusIndex(order)
                        ? 'tw-bg-green-100 tw-text-green-700'
                        : idx < getCurrentStatusIndex(order)
                        ? 'tw-bg-gray-200 tw-text-gray-700'
                        : 'tw-bg-gray-100 tw-text-gray-400',
                    ]"
                  >
                    Order Status: {{ formatTypeAsStatus(status) }}
                  </div>
                  <span v-if="findLogByStatus(order, status)" class="tw-ml-3 tw-text-gray-500 tw-font-light tw-text-xs tw-min-w-[150px] tw-text-right">
                    {{ formatDate(findLogByStatus(order, status).insertedDate) }}
                  </span>
                </div>
              </div>
              <div v-if="statuses[getCurrentStatusIndex(order)] === 'shipped' && getLastLogWithTracking(order) && getLastLogWithTracking(order).trackingUrl" class="tw-mt-3">
                <div class="tw-flex tw-items-start tw-gap-2">
                  <span class="tw-inline-flex tw-items-center tw-justify-center tw-bg-green-100 tw-text-green-600 tw-rounded-full tw-p-1">
                    <list-icon class="tw-h-4 tw-w-4" />
                  </span>
                  <div>
                    <div class="tw-text-gray-700 tw-text-sm tw-mb-1">
                      {{
                        getLastLogWithTracking(order).description ||
                          "Your medication has been filled and is being prepared for shipping! Once the carrier is ready to receive the medication from the Pharmacy, it will arrive to you within 2 days once they pick it up. The average estimated time to shipping from this status is: 3 days."
                      }}
                    </div>
                    <!-- <div class="tw-text-xs tw-text-gray-400">
                      {{ formatDate(getLastLogWithTracking(order).insertedDate) }}
                    </div> -->
                  </div>
                </div>
                <a
                  :href="getLastLogWithTracking(order).trackingUrl"
                  target="_blank"
                  class="tw-mt-3 tw-inline-block tw-text-white tw-bg-primary-500 hover:tw-bg-primary-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-primary-500  tw-px-6 tw-py-2 tw-rounded-md tw-text-sm  tw-transition"
                  >Tracking URL</a
                >
              </div>
            </div>
            <!-- end RIGHT -->
          </div>
        </div>
      </base-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ListIcon } from "@/assets/svgs";
export default {
  name: "UserPlanTrackingList",
  props: {
    userId: String,
    userBusinessPlanId: String,
  },
  components: {
    ListIcon,
  },
  data() {
    return {
      isLoading: false,
      orderTrackings: [],
      statuses: ["new", "inpharmacy", "readytopack", "readytoship", "shipped"],
      stepHeight: 50,
    };
  },
  created() {
    this.getOrderTrackingLogs();
  },
  methods: {
    async getOrderTrackingLogs() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/users/${this.userId}/plans/${this.userBusinessPlanId}/order-status-logs`);
        this.orderTrackings = response.data;
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(dt) {
      if (!dt) return "-";
      return moment(dt).format("M/D/YY h:mm A");
    },
    formatTypeAsStatus(type) {
      if (!type) return "";
      switch (type.toLowerCase()) {
        case "new":
          return "New";
        case "inpharmacy":
          return "In Pharmacy";
        case "readytopack":
          return "Ready To Pack";
        case "readytoship":
          return "Ready To Ship";
        case "shipped":
          return "Shipped";
        default:
          if (type.toLowerCase().startsWith("order_")) {
            const readable = type.replace(/_/g, " ").replace("order ", "");
            return readable.charAt(0).toUpperCase() + readable.slice(1);
          }
          return type.charAt(0).toUpperCase() + type.slice(1);
      }
    },
    getCurrentStatusIndex(order) {
      if (!order || !order.logs || !order.logs.length) return 0;
      const lastLogStatus = order.logs[order.logs.length - 1].status.toLowerCase();
      const idx = this.statuses.findIndex((s) => s.toLowerCase() === lastLogStatus);
      return idx === -1 ? 0 : idx;
    },
    findLogByStatus(order, status) {
      if (!order || !order.logs) return undefined;
      return order.logs.find((x) => x.status && x.status.toLowerCase() === status.toLowerCase());
    },
    getLastLogWithTracking(order) {
      if (!order.logs || !order.logs.length) return null;
      for (let i = order.logs.length - 1; i >= 0; i--) {
        if (order.logs[i].trackingUrl) {
          return order.logs[i];
        }
      }
      return null;
    },
  },
};
</script>
